import { useTranslation } from 'react-i18next';
import { CourseEnrollmentStates } from '../../../types/CourseValidationType';

export type StudentStatus = CourseEnrollmentStates | 'calc';

const getStatusColor = (status: StudentStatus) => {
  const colors: Partial<Record<StudentStatus, string>> = {
    [CourseEnrollmentStates.Approved]: 'approved',
    [CourseEnrollmentStates.Reject]: 'failed',
    [CourseEnrollmentStates.Pending]: 'pending',
    calc: 'calculating',
  };

  return colors[status];
};

interface Props {
  status: StudentStatus;
  shortVersion?: boolean;
}

export function StudentStatusBadge({ status, shortVersion = false }: Props) {
  const { t } = useTranslation();

  const getStatusText = (status: StudentStatus) => {
    const fullText = t(`studentGradesClosure.search.studentStatuses.${status}`);
    return shortVersion ? fullText.slice(0, 1) : fullText;
  };

  return (
    <span className={`student-status-badge ${getStatusColor(status)}`}>
      {getStatusText(status)}
    </span>
  );
}
